/** @jsxImportSource @emotion/react */
import React from "react";
import { css, useTheme } from "@emotion/react";
import { useLanguage } from "LanguageContext";

export default function Loader() {
  const { t } = useLanguage();
  const theme = useTheme();

  const cardContainer = css`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${theme.colors.gradient};
    background-size: 300% 100%;
    animation: gradientAnimation 5s ease infinite;
    box-shadow: ${theme.shadows.medium};
    padding: ${theme.spacing["5xl"]};
    border-radius: ${theme.radius.sm};
    width: 100%;
    box-sizing: border-box;
    margin: ${theme.spacing["5xl"]} 0;
    flex-direction: row;
    color: ${theme.colors.white};
    font-size: ${theme.typography.heading3_medium.fontSize};
    text-align: center;

    @keyframes gradientAnimation {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  `;

  return <div css={cardContainer} dangerouslySetInnerHTML={{__html: t("analyse_loader_text")}} />;
}
